import GraphContent from "../graph_content";
import { getSensorData } from "./get_sensor_data";

export function reloadGraph(self: GraphContent, interval: number) {
  self.reloadEvent = setInterval(() => {
    getSensorData(self);
  }, interval * 1000);
}
